import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  guide: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20desk%20setup%20with%20an%20open%20guidebook%2C%20a%20pen%2C%20and%20a%20laptop%20displaying%20a%20clean%20interface%2C%20soft%20cream%20and%20beige%20tones%2C%20gentle%20natural%20lighting%2C%20professional%20and%20inviting%20atmosphere%2C%20abstract%20geometric%20elements%20in%20background&width=800&height=500&seq=cat-guide-img&orientation=landscape',
  features: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20dashboard%20interface%20with%20clean%20widgets%20and%20data%20visualizations%2C%20warm%20golden%20accents%2C%20cream%20background%2C%20abstract%20floating%20geometric%20elements%2C%20soft%20natural%20light%2C%20professional%20tech%20aesthetic%2C%20no%20text&width=800&height=500&seq=cat-features-img&orientation=landscape',
  faq: 'https://readdy.ai/api/search-image?query=A%20calm%20and%20inviting%20help%20center%20scene%20with%20soft%20warm%20lighting%2C%20question%20mark%20shapes%20as%20abstract%20geometric%20decorations%2C%20cream%20and%20beige%20tones%2C%20clean%20minimalist%20style%2C%20friendly%20and%20approachable%20vibe%2C%20no%20text&width=800&height=500&seq=cat-faq-img&orientation=landscape',
};

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
            分类浏览
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索您感兴趣的内容
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            按分类浏览平台相关内容，快速找到您需要的信息
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden cursor-pointer h-64"
            >
              <img
                src={categoryImages[cat.slug] || categoryImages.guide}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-black/10"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50/20 backdrop-blur-sm text-background-50 mb-3">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading font-semibold text-lg text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-background-200/80 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}